<script setup>
import {computed} from 'vue'
import {useViewStore} from '@/stores/view'

// Define Props
const props = defineProps({
    viewId: String,
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Computed Properties
const tableName = computed(() => viewStore.tableName || '')

const noContentMessage = computed(() => {
    return tableName.value.indexOf('product_variations__') === 0
        ? 'No variations.'
        : 'No content.'
})
</script>

<template>
    <div class="text-center">
        {{ noContentMessage }}
    </div>
</template>